import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { addAdmin } from "src/store/reducers/adminsSlice";
import { closeModal, showModal } from 'src/store/reducers/modalSlice';

import { PasswordInput, SubmitButton } from "../../components";

export const CreatePasswordAdminScreen = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { isAddRequestLoading } = useAppSelector((state) => state.admins)

  const onPasswordInputValidate = (password: string) => {
    if (password.length < 8) {
      return "The value is not a valid password";
    }
    return "";
  };

  const onPasswordInputReValidate = (rePassword: string) => {
    if (rePassword.length < 8) {
      return "The value is not a valid password";
    }
    return "";
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const password = data.get("password");
    const repeatPassword = data.get("re-password");

    const path = new URLSearchParams(window.location.search);
    const token = path.get("token");

    if (
      !onPasswordInputValidate(password as string) &&
      !onPasswordInputReValidate(repeatPassword as string) &&
      password === repeatPassword
    ) {
      dispatch(
        addAdmin({
          token,
          password: repeatPassword,
          onSuccess: () => {
            navigate("*");
          },
          onFailure: (error: any) => {
            dispatch(
              showModal({
                modalType: "DELETE",
                title: `${error?.response?.data?.detail || error.message}`,
                okButtonTitle: "Ok, I got it",
                isButtonCancel: true,
                onButtonClick: () => {
                  dispatch(closeModal());
                },
              })
            );
          },
        })
      );
    }
  };

  return (
    <Box display="flex">
      <Box sx={{
        borderRadius: 4,
        paddingX: 4,
        maxWidth: 494,
        backgroundColor: "white",
      }}>
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              position: "relative",
              justifyContent: "center",
              flexDirection: "column",
              flex: 1,
            }}
          >
            <Box
              sx={{
                mb: 4,
              }}
            >
              <img alt="Logo" width="40px" src="/images/logo.png" />
            </Box>
          </Box>
          <Box
            sx={{
              mb: "24px",
            }}
          >
            <Typography component="h1" variant="h2">
              Create password
            </Typography>
            <Typography
              sx={{
                color: "#363636",
                fontSize: "16px",
                fontWeight: "400",
                marginTop: "40px",
                textAlign: "left",
              }}
            >
              Please enter a password below
            </Typography>
          </Box>
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <PasswordInput
              id="password-input"
              label="Password"
              name="password"
              initialValue=""
              validationFn={onPasswordInputValidate}
            />
            <PasswordInput
              id="re-password-input"
              label="Re-enter new password"
              name="re-password"
              initialValue=""
              validationFn={onPasswordInputReValidate}
            />
            <SubmitButton
              title="Create password"
              type="submit"
              isLoading={isAddRequestLoading}
              fullWidth
              size="large"
              disableRipple
              disableElevation
              variant="contained"
              sx={{ mt: 3, mb: 4 }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
